import { ModelNamedProperty } from "../models/named-property";

export class ScriptNamedProperty extends ModelNamedProperty {
	pathToFilterPath(): string {
		return this.path;
	}
}